import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Report/PowerBiConfig', method: 'GET', body: null, token: token })
}
